module.exports = __webpack_public_path__ + "img/cart.872edcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/cart.png
// module id = LV8R
// module chunks = 5 89